import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useDropzoneAreaStyles = makeStyles((theme) =>
  createStyles({
    '@keyframes progress': {
      '0%': {
        backgroundPosition: '0 0'
      },
      '100%': {
        backgroundPosition: '-70px 0'
      }
    },

    action: {
      marginTop: 24,
      display: 'flex',
      justifyContent: 'flex-end'
    },

    button: {
      '&:not(:last-child)': {
        marginRight: 10
      }
    },

    card: {
      marginBottom: 48
    },

    item: {
      position: 'relative',
      zIndex: 10,
      textAlign: 'center',

      '&:hover $removeButton': {
        opacity: 1
      }
    },

    image: {
      width: 56,
      height: 56,
      marginRight: 12,
      opacity: 1,
      zIndex: 5,
      maxWidth: '100%',
      boxShadow: theme.shadows[1],
      boxSizing: 'border-box',
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
      borderRadius: 4
    },

    removeButton: {
      transition: '.5s ease',
      marginLeft: 'auto',
      opacity: 0,
      width: 40,
      height: 40,

      '&:focus': {
        opacity: 1
      }
    },

    root: {
      minHeight: 'auto',
      padding: theme.spacing(1.5, 3),
      margin: theme.spacing(3, 0),
      width: '100%',
      backgroundColor: theme.palette.background.paper,
      border: 'dashed',
      borderColor: theme.palette.divider,
      borderRadius: theme.shape.borderRadius,
      boxSizing: 'border-box',
      cursor: 'pointer',
      overflow: 'hidden'
    },

    active: {
      animation: '$progress 2s linear infinite !important',
      backgroundImage: `repeating-linear-gradient(-45deg, 
        ${theme.palette.background.paper}, 
        ${theme.palette.background.paper} 25px, 
        ${theme.palette.divider} 25px, 
        ${theme.palette.divider} 50px)
        `,
      backgroundSize: '150% 100%',
      border: 'solid',
      borderColor: theme.palette.primary.light
    },

    invalid: {
      backgroundImage: `repeating-linear-gradient(-45deg, 
        ${theme.palette.error.light}, 
        ${theme.palette.error.light} 25px, 
        ${theme.palette.error.dark} 25px, 
        ${theme.palette.error.dark} 50px)`,
      borderColor: theme.palette.error.main
    },

    textContainer: {
      textAlign: 'center'
    },

    error: {
      borderColor: theme.palette.error.main
    },

    hideDragzone: {
      display: 'none'
    },

    text: {
      color: theme.palette.text.secondary,
      margin: 0,
      ...theme.typography.body2
    },

    icon: {
      color: theme.palette.text.secondary,
      width: 25,
      height: 25
    },

    previewList: {
      marginBottom: theme.spacing(2)
    }
  })
)
